import * as React from 'react';
import { useSelector } from 'react-redux';

import { PageTitle } from '../../components/PageTitle';
import { Layout } from '../../components/Layout';
import { selectPageTitle } from '../../selectors/seoData';

export const PageTitleContainer: React.VFC = () => {
  const title = useSelector(selectPageTitle);

  return (
    <Layout>
      <PageTitle text={title} />
    </Layout>
  );
};
